import { useEffect, type MutableRefObject } from 'react'

type UseStepFocusEffectArgs = {
  currentStep: number
  isCheckingStepAccess: boolean
  stepValidationError: string | null
  stepContentRef: MutableRefObject<HTMLDivElement | null>
  checkingStepRef: MutableRefObject<HTMLDivElement | null>
  validationMessageRef: MutableRefObject<HTMLDivElement | null>
}

export function useStepFocusEffect({
  currentStep,
  isCheckingStepAccess,
  stepValidationError,
  stepContentRef,
  checkingStepRef,
  validationMessageRef
}: UseStepFocusEffectArgs) {
  useEffect(() => {
    const focusTarget = isCheckingStepAccess
      ? checkingStepRef.current
      : stepValidationError
        ? validationMessageRef.current
        : stepContentRef.current

    if (!focusTarget) {
      return
    }

    const frameId = window.requestAnimationFrame(() => {
      if (!isCheckingStepAccess && !stepValidationError) {
        window.scrollTo({ top: 0, behavior: 'auto' })
      }

      focusTarget.focus({ preventScroll: true })
    })

    return () => {
      window.cancelAnimationFrame(frameId)
    }
  }, [
    checkingStepRef,
    currentStep,
    isCheckingStepAccess,
    stepContentRef,
    stepValidationError,
    validationMessageRef
  ])
}
